import React from "react";

const About = () => {
  return (
    <div className="about">
      {/*<h1>ABOUT TEST</h1>*/}
      <div className="aboutSection">
          <picture>
            <img
                src={process.env.PUBLIC_URL + "/img/photo_about.webp"}
                alt="Photo de l'artiste"
            />
          </picture>
          <div className="aboutSection_text">
            <p>
                Né en 1990 et installé à Montréal depuis 2018, je suis un artiste pluridisciplinaire dont la pratique s’articule principalement autour de l’encre à alcool. 
                Depuis 2019, je développe un travail qui conjugue géométrie maîtrisée et motifs organiques imprévisibles, explorant le dialogue entre contrôle et hasard.
            <br /><br />
            </p>
            <p>
            Les formes rigoureuses renferment des textures mouvantes qui rappellent les dynamiques de la nature : un système en apparence chaotique, mais d’une perfection intrinsèque lorsqu’on l’observe dans sa globalité.
                <br /><br />
            </p>
            <p>
                Daltonien, ma perception altérée des couleurs influence profondément ma vision du monde et ma pratique artistique. Elle me pousse à aborder la couleur non comme une évidence, mais comme une émotion, une matière vivante à apprivoiser.
                <br /><br />
            </p>
            <p>
                Inspiré par mon enfance en Méditerranée, mes œuvres reflètent la lumière, les couleurs et les atmosphères marines, tout en abordant des thèmes liés à la condition humaine — ses accomplissements, ses dérives et sa quête d’équilibre face à un monde évoluant de plus en plus rapidement. 
                Situé à la croisée de l’abstraction géométrique et de l’art optique, mon travail a été présenté dans divers contextes culturels depuis 2023, et continue d’évoluer à travers des projets où se rencontrent recherche visuelle et expérimentation technique.
                <br /><br /><br />
            </p>
            <p>
            Contact : <a className="mail" href="mailto:antoinedevictor.art@gmail.com">antoinedevictor.art@gmail.com</a>
            </p>

          </div>
      </div>
    </div>
  );
};

export default About;